export default __webpack_public_path__ + "static/media/badge.21a8272b.svg";